// Surface Exports
export const appearance = {
  black: 'rgba(10, 10, 16, 1)',
  counterBackgroundColor: 'rgb(227, 234, 248)',
  countersignBorderColor: '#7599e0',
  deselectedColor: '#fef0dd',
  fixedBackgroundColor: 'rgba(250, 250, 250, 0.7)',
  fixedBorderColor: '#b9b9b9',
  fontStyle: '14px Roboto, Helvetica, Arial',
  guideColor: 'rgba(160, 160, 160, 0.9)',
  primaryBackgroundColor: 'rgb(254, 240, 221)',
  primaryBorderColor: '#fec678',
  selectedBorderColor: '#826af6',
  selectedColor: 'rgba(178,235,242,.3)',
  selectionBackgroundColor: 'rgba(160, 160, 160, 0.07)',
  selectionBorderColor: 'rgba(160, 160, 160, 0.9)',
  transparent: 'rgba(0, 0, 0, 0)',
};
